import React, { useState, useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaInfoCircle, FaDownload, FaLaptop, FaMemory, FaHdd, FaMicrochip, FaFileAlt } from 'react-icons/fa';

const Changelog25Module1 = () => {
  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [expandedSection, setExpandedSection] = useState('changes');
  
  const toggleSection = (section) => {
    setExpandedSection(section === expandedSection ? null : section);
  };

  const changelogData = [
    {
      version: "11.0.61",
      date: "31 de enero de 2026",
      changes: [
        "PP-7762: Se optimizó la aplicación del porcentaje de pie de precios unitarios cuando el porcentaje de financiamiento es menor a 4 decimales.",
        "PP-7761: Se actualizó el valor de la UMA al año 2026.",
        "PP-7752: Ahora es posible, en el Diagrama de Gantt, vincular 2 tareas, aún cuando no tengan descripción.",
        "PP-7750: Se actualizó el Salario mínimo de 2026 en plantillas de FSR.",
        "PP-7737: En indirectos anualizados, se agregó un renglón que calcula el importe de indirectos de oficina central, una vez calculado el porcentaje de oficina central anualizado.",
        "PP-7735: Se revisó el cálculo del financiamiento, así como los cálculos para la obtención del importe de indirectos y su correcta aparición en la vista de indirectos.",
        "GIA-18: En la vista de Estimaciones, se revisaron y optimizaron los filtros por columna.",
        "GIA-17: En la vista de Estimaciones, se optimizaron los procesos involucrados para la recepción de los avances desde M2."
      ]
    },
    {
      version: "11.0.53",
      date: "27 de septiembre de 2025",
      changes: [
        "PP-7719: Se revisaron los procesos relacionados con la creación de categorías de mano de obra de indirectos.",
        "PP-7713: Al ejecutar la aplicación, se puede crear o abrir la instancia OpusLocal si así se requiere.",
        "PP-7711: Se optimizó la apertura de obras en el sistema, especialmente, la apertura de obras en conjunto.",
        "PP-7710: Al instalar OPUS 25 en un equipo con versión anterior OPUS24 y la carpeta de obras no está ligada a ONEDRIVE, la nueva instalación conservará la ruta establecida. En caso contrario, se creará una nueva ruta de guardado en una carpeta directamente localizada en la unidad C del equipo de cómputo.",
        "PP-7709: Se implementó un script que repara el servidor local de sql server OpusLocal.",
        "PP-7702: En la herramienta Comparativo de presupuestos en \"Diferentes hojas\", se agregó la columna \"Nivel\" a las hojas del libro creado.",
        "PP-7701: En la herramienta Comparativo de presupuestos, en \"RESUMEN GLOBALIZADO\" se optimizó el cálculo del dato \"Diferencia\".",
        "PP-7699: En la herramienta Comparativo de presupuestos, para todas las hojas, se muestran las cantidades de agrupador.",
        "PP-7697: En la herramienta Comparativo de presupuestos en \"Diferentes hojas\", se mejoraron procesos para visualizar correctamente los totales al pie de todas las hojas.",
        "PP-7696: En la herramienta Comparativo de presupuestos en \"Diferentes hojas\", se agregó la hoja \"Comparativo consolidado\" con la colección de Renglones Combinados.",
        "PP-7695: En la herramienta Comparativo de presupuestos en \"Diferentes hojas\", se optimizó el layout de \"Resumen globalizado\".",
        "PP-7690: Se hizo más eficiente el Comparativo de presupuestos en modo \"consolidado\", al retirar las columnas sin información práctica.",
        "PP-7689: En la herramienta Comparativo de presupuestos, se agregó la columna Tipo a las hojas de \"Tabla comparativa\", \"Renglones que se eliminan\" y \"Renglones que se ejecutan\", \"Resumen globalizado\" y \"Consolidado\".",
        "PP-7677: En la herramienta Comparativo de presupuestos, se implementó soporte para conceptos que cambiaron de precio unitario."
      ]
    },
    {
      version: "11.0.29",
      date: "15 de enero de 2025",
      changes: [
        "PP-7682: Se revisó la hoja de cálculo del FASAR, los días festivos por ley y las horas de la jornada.",
        "PP-7676: En la herramienta Comparativo de presupuestos, se mejoró la salida con opción \"En varias hojas\".",
        "PP-7674: Se optimizó la impresión directa de la Explosión de insumos, y la correcta alineación de los datos en las columnas participantes.",
        "PP-7669: Se habilitó la visualización y edición de la columna Referencia en la vista Hoja de Presupuesto Programable.",
        "PP-7657: Se implementaron reportes de Explosión de insumos por agrupador, en la vista Explosión de insumos.",
        "PP-7656: Se implementó el reporte de Explosión de insumos por concepto, en la vista Explosión de insumos.",
        "PP-7125: Se revisó la herramienta para el Diseño de encabezado y pie de página, y se ajustó la ubicación del Pie del Informe."
      ]
    },
    {
      version: "11.0.27",
      date: "8 de enero de 2025",
      changes: [
        "PP-7670: En la herramienta Comparativo de presupuestos, se mejoró la salida con opción \"En varias hojas\".",
        "PP-7653: Se revisó y optimizó el proceso de impresión del reporte de sistema \"Análisis de precios unitarios\", seleccionando la alternativa para imprimir determinados agrupadores."
      ]
    },
    {
      version: "11.0.15",
      date: "1 de julio de 2025",
      changes: [
        "PP-7652: Se revisó el reporte de Análisis de Precio Unitario y se optimizaron los procesos relacionados con el desglose de auxiliares y cantidades al pie de los mismos.",
        "PP-7647: Se optimizó la selección de renglones y los procedimientos de arrastrar y soltar selección múltiple.",
        "PP-7650: Se mejoró la vista Carga de Recursos: se hizo más eficiente la programación para la visualización de las gráficas.",
        "PP-7645: Se realizó una revisión de la vista de Programa de Obra y se optimizó la introducción de datos de inicio y término de los conceptos del presupuesto, así como el envío de mensajes por parte del sistema para notificar de forma más eficiente posibles incidencias encontradas.",
        "PP-7643: Se perfeccionaron operaciones internas relacionadas con el cambio de ruta del Explorador de Reportes."
      ]
    }
  ];

  const systemRequirements = {
    minimum: {
      processor: "Intel Core i3 o AMD equivalente",
      ram: "8 GB RAM",
      storage: "2 GB de espacio disponible",
      graphics: "Tarjeta gráfica compatible con DirectX 11",
      os: "Windows 10 (64-bit) o superior",
      display: "Resolución mínima 1366x768",
      additional: "Conexión a Internet para activación y actualizaciones"
    },
    recommended: {
      processor: "Intel Core i5 o AMD Ryzen 5 o superior",
      ram: "16 GB RAM o más",
      storage: "5 GB de espacio disponible en SSD",
      graphics: "Tarjeta gráfica dedicada con 2 GB de VRAM",
      os: "Windows 11 (64-bit)",
      display: "Resolución 1920x1080 o superior",
      additional: "Conexión a Internet de alta velocidad"
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Changelog OPUS 25 Módulo 1 | Ecosoft"
        description="Historial de cambios y mejoras de OPUS 25 Módulo 1: Presupuesto Programable."
        name="Changelog25Module1"
        type="website"
      />
      
      {/* Hero Section */}
      <section id="overview" className="relative h-[350px] bg-gradient-to-r from-[#003171] to-[#0066CC]">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-2xl text-white">
            <h1 className="text-4xl font-bold mb-2">OPUS 25 - Módulo 1</h1>
            <h2 className="text-2xl font-semibold mb-4">Presupuesto Programable</h2>
            <p className="text-lg mb-6">
              Consulte el historial de cambios y mejoras del Módulo 1 de OPUS 25.
            </p>
            <div className="flex gap-4">
              <Link to="/soporte/descargas" className="inline-flex items-center text-white hover:underline">
                <FaArrowRight className="mr-2 rotate-180" /> Volver al Centro de Descargas
              </Link>
              <Link to="/modulos/presupuesto-programable" className="inline-flex items-center text-white hover:underline">
                <FaInfoCircle className="mr-2" /> Ver información del módulo
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Main Content */}
      <section className="py-12 px-6">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8">
            <div className="flex items-center mb-6">
              <div className="bg-[#0055B8]/10 p-3 rounded-full mr-4">
                <FaInfoCircle className="text-[#0055B8] text-2xl" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#1A2B39]">Módulo 1: Presupuesto Programable</h2>
                <p className="text-gray-600">Historial de cambios y mejoras de la versión OPUS 25</p>
              </div>
            </div>
            
            <p className="mb-6 text-gray-700">
              El Módulo 1 de OPUS 25 le permite elaborar presupuestos de obra de manera rápida y sencilla. Con nuestras continuas mejoras, este módulo se mantiene a la vanguardia para satisfacer las necesidades de los profesionales de la construcción. A continuación, encontrará el detalle de las actualizaciones más recientes.
            </p>
            
            <div className="flex justify-end">
              <Link 
                to="/soporte/descargas" 
                className="inline-flex items-center text-[#0055B8] hover:underline"
              >
                <FaDownload className="mr-2" /> Ir al centro de descargas
              </Link>
            </div>
          </div>
          
          {/* Changelog Section */}
          <div 
            className={`bg-white p-6 rounded-lg shadow border border-gray-200 mb-8 ${expandedSection === 'changes' ? 'ring-2 ring-[#0055B8]' : ''}`}
            onClick={() => toggleSection('changes')}
          >
            <div className="flex justify-between items-center cursor-pointer">
              <h2 className="text-2xl font-bold text-[#1A2B39]">Historial de cambios</h2>
              <span className="text-[#0055B8]">{expandedSection === 'changes' ? '−' : '+'}</span>
            </div>
          </div>
          
          {expandedSection === 'changes' && (
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8">
              <div className="space-y-10">
                {changelogData.map((version, index) => (
                  <div key={index} className="border-b border-gray-200 pb-8 last:border-b-0 last:pb-0">
                    <div className="flex items-start gap-4 md:gap-8">
                      <div className="bg-[#0055B8]/10 p-3 rounded-full">
                        <FaInfoCircle className="text-[#0055B8] text-xl" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-[#1A2B39] mb-2">Versión {version.version}</h3>
                        <p className="text-gray-600 mb-4">Fecha: {version.date}</p>
                        
                        <h4 className="font-bold text-[#0055B8] mb-2">Cambios y mejoras:</h4>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                          {version.changes.map((change, changeIndex) => (
                            <li key={changeIndex}>{change}</li>
                          ))}
                        </ul>
                        
                        <div className="mt-6">
                          <Link 
                            to="/soporte/descargas" 
                            className="inline-flex items-center px-4 py-2 bg-[#0055B8] text-white rounded hover:bg-[#003a80] transition-colors"
                          >
                            <FaDownload className="mr-2" /> Descargar esta versión
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* System Requirements Section */}
          <div 
            className={`bg-white p-6 rounded-lg shadow border border-gray-200 mb-8 ${expandedSection === 'requirements' ? 'ring-2 ring-[#0055B8]' : ''}`}
            onClick={() => toggleSection('requirements')}
          >
            <div className="flex justify-between items-center cursor-pointer">
              <h2 className="text-2xl font-bold text-[#1A2B39]">Requisitos del sistema</h2>
              <span className="text-[#0055B8]">{expandedSection === 'requirements' ? '−' : '+'}</span>
            </div>
          </div>
          
          {expandedSection === 'requirements' && (
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-bold text-[#1A2B39] mb-4 flex items-center">
                    <FaLaptop className="text-[#0055B8] mr-2" /> Requisitos mínimos
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <FaMicrochip className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Procesador:</span> {systemRequirements.minimum.processor}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaMemory className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Memoria RAM:</span> {systemRequirements.minimum.ram}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaHdd className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Almacenamiento:</span> {systemRequirements.minimum.storage}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Tarjeta gráfica:</span> {systemRequirements.minimum.graphics}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Sistema operativo:</span> {systemRequirements.minimum.os}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Pantalla:</span> {systemRequirements.minimum.display}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Adicional:</span> {systemRequirements.minimum.additional}
                      </div>
                    </li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold text-[#1A2B39] mb-4 flex items-center">
                    <FaLaptop className="text-[#0055B8] mr-2" /> Requisitos recomendados
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <FaMicrochip className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Procesador:</span> {systemRequirements.recommended.processor}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaMemory className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Memoria RAM:</span> {systemRequirements.recommended.ram}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaHdd className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Almacenamiento:</span> {systemRequirements.recommended.storage}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Tarjeta gráfica:</span> {systemRequirements.recommended.graphics}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Sistema operativo:</span> {systemRequirements.recommended.os}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Pantalla:</span> {systemRequirements.recommended.display}
                      </div>
                    </li>
                    <li className="flex items-start">
                      <FaInfoCircle className="text-[#0055B8] mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <span className="font-semibold">Adicional:</span> {systemRequirements.recommended.additional}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {/* Call to Action */}
          <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8 text-center">
            <h2 className="text-2xl font-bold text-[#1A2B39] mb-4">¿Listo para actualizar?</h2>
            <p className="text-gray-700 mb-6 max-w-3xl mx-auto">
              Descargue la última versión de OPUS 25 Módulo 1 y disfrute de todas las mejoras y nuevas funcionalidades que hemos desarrollado para optimizar su trabajo.
            </p>
            <div className="flex justify-center gap-4">
              <Link 
                to="/soporte/descargas" 
                className="inline-flex items-center px-6 py-3 bg-[#0055B8] text-white rounded-md hover:bg-[#003a80] transition-colors text-lg font-medium"
              >
                <FaDownload className="mr-2" /> Ir al centro de descargas
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Changelog25Module1; 